import { render, staticRenderFns } from "./HorseCloture.vue?vue&type=template&id=561fc46e&"
import script from "./HorseCloture.vue?vue&type=script&lang=js&"
export * from "./HorseCloture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports